import script from "./Lenders.vue?vue&type=script&setup=true&lang=js"
export * from "./Lenders.vue?vue&type=script&setup=true&lang=js"

import "./Lenders.vue?vue&type=style&index=0&id=3e84137c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e84137c"]])

export default __exports__